import LocalPointsService from '../api/local-points'
import RoutingService from '../../api/routing'
import {
  FILTER_KEY_EVENT_TYPES,
  FILTER_KEY_INCLUDE_VIRTUAL,
  FILTER_KEY_LABELS,
  FILTER_KEY_LOCATION,
  FILTER_KEY_REGIONS,
  FILTER_KEY_START_DATE_RANGE,
  FILTER_KEY_TYPES,
  FILTER_KEY_UPCOMING_ONLY,
  FILTER_KEY_PARTNERSHIP
} from '../filter-keys'
import {dataUrlFilterOptions, pointsUrlOptions} from './helpers'

export default {
  getPoints({commit, state, getters}) {
    LocalPointsService.listPoints({
      options: pointsUrlOptions(state, getters)
    }).then(points => {
      const pointsWithKey = points.map(point => {
        point.key = `${point.type}${point.id}`
        return point
      })
      commit('setPoints', pointsWithKey)

      if (!this.state.pointsInitiallyLoaded) {
        commit('setPointsInitiallyLoaded')
      }
    })

  },

  getDetailedLocations({commit, state, getters}) {
    commit('setIsLoadingList', true)
    LocalPointsService.listDetailedLocations({
      options: dataUrlFilterOptions(state, getters)
    }).then(resp => {
      commit('setDetailedLocations', resp.data)
      commit('setPaginationCounts', resp.meta)
      commit('setSearchedLocation', resp.meta.filter.searchedLocation)

      // If the current page is now beyond the total number of pages of results,
      // go back to page 1, replacing the current URL to avoid back-button weirdness.
      if (state.pagination.totalPages < state.pagination.page) {
        commit('setPage', 1)
        RoutingService.addHistoryItem(getters.pageUrlFilterOptions, true)
        this.dispatch('getDetailedLocations')
      }

      commit('setIsLoadingList', false)
    })
  },

  getLocationDetails({state}, points) {
    LocalPointsService.getLocationDetails({
      locations: points
    }).then(response => {
      state.locationDetailsLookup[JSON.stringify(points)] = response.data
    })
  },

  loadDataFromUrl({dispatch}) {
    dispatch('getDetailedLocations')
  },

  applyEventTypeFilter(context, eventTypes) {
    applyFilter.bind(this)(context, FILTER_KEY_EVENT_TYPES, eventTypes, eventTypes.length > 0)
  },

  applyStartDateFilter(context, startDateRange) {
    applyFilter.bind(this)(context, FILTER_KEY_START_DATE_RANGE, startDateRange, !!startDateRange)
  },

  applyIncludeVirtualFilter(context, includeVirtual) {
    applyFilter.bind(this)(context, FILTER_KEY_INCLUDE_VIRTUAL, includeVirtual, includeVirtual !== 'all')
  },

  applyLabelFilter(context, labels) {
    applyFilter.bind(this)(context, FILTER_KEY_LABELS, labels, labels.length > 0)
  },

  applyLocationFilter({state, dispatch, getters}, query) {
    // Remove any existing filter
    state.filters = state.filters.filter(f => f.type !== FILTER_KEY_LOCATION)

    // Add a location filter if a query is present
    if (query) {
      state.filters.push({type: FILTER_KEY_LOCATION, value: query})
    }

    // Reset to page 1
    this.commit('setPage', 1)

    // Update the URL
    RoutingService.addHistoryItem(getters.pageUrlFilterOptions)

    // Fetch updated locations data
    dispatch('getDetailedLocations')
  },

  applyRegionFilter(context, regions) {
    applyFilter.bind(this)(context, FILTER_KEY_REGIONS, regions, regions.length > 0)
  },

  applyTypeFilter(context, types) {
    applyFilter.bind(this)(context, FILTER_KEY_TYPES, types, types !== null)
  },

  applyUpcomingOnlyFilter(context, upcomingOnly) {
    applyFilter.bind(this)(context, FILTER_KEY_UPCOMING_ONLY, upcomingOnly, !upcomingOnly)
  },

  applyPartnershipFilter(context, partnershipId) {
    applyFilter.bind(this)(context, FILTER_KEY_PARTNERSHIP, partnershipId, true)
  },

  paginate({dispatch, getters}, page) {
    this.commit('setPage', page)
    RoutingService.addHistoryItem(getters.pageUrlFilterOptions)
    dispatch('getDetailedLocations')
  }
}

function applyFilter({state, dispatch, getters}, filterKey, filterValue, shouldAddFilter) {
  // Remove any existing filter
  state.filters = state.filters.filter(f => f.type !== filterKey)

  // Add filter if appropriate
  if (shouldAddFilter) {
    state.filters.push({type: filterKey, value: filterValue})
  }

  // Reset to page 1
  this.commit('setPage', 1)

  // Update the URL
  RoutingService.addHistoryItem(getters.pageUrlFilterOptions)

  // Fetch updated locations and points data
  dispatch('getDetailedLocations')
  dispatch('getPoints')
}
